import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ADMIN_RESIDUAL_VALUE_GRIDS_READ } from 'constants/rightsCodes';
import ResidualValueGridContainer from './ResidualValueGridContainer';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import IconButton from 'components/common/buttons/IconButton';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const handleBack = useCallback(() => {
    historyContext.push('/residualValueGrids');
  }, [historyContext]);

  return (
    <>
      <Portal container={getElemByAreaKey(areas.header)}>
        <FlexBox
          xs={{ direction: 'column', gap: 0, alignItems: 'start' }}
          gap={2}
          justifyContent='space-between'
          alignItems='center'
          grow
          my={1}
        >
          <FlexBox id='residual-value-grid-title' />
          <FlexBox id='residual-value-grid-state' mr={2} />
        </FlexBox>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <FlexBox gap={0.5}>
          <IconButton type='backward' onClick={handleBack} size='medium' iconFontSize='medium' />
        </FlexBox>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_RESIDUAL_VALUE_GRIDS_READ}>
        <ResidualValueGridContainer />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
